import type { Asset } from '@schibsted-svp/svp-api-types';

export function isTTSContent(asset: Asset | undefined): boolean {
  return Boolean(asset?.additional?.metadata?.tts_articleId);
}
